import React from "react";

export interface DiscountWarningModalProps {
  isOpen: boolean;
  onRecalculateAuto: () => void;
  onKeepManual: () => void;
  isLoading: boolean;
}

/** Warning dialog shown when dates/rooms change and discounts are locked (manual mode) */
const DiscountWarningModal: React.FC<DiscountWarningModalProps> = ({
  isOpen,
  onRecalculateAuto,
  onKeepManual,
  isLoading,
}) => {
  const dialogRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (isOpen && dialogRef.current) {
      dialogRef.current.focus();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="discount-warning-title"
      onKeyDown={(e) => {
        if (e.key === "Escape") onKeepManual();
      }}
      tabIndex={-1}
      ref={dialogRef}
    >
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h3 id="discount-warning-title" className="text-lg font-semibold mb-4">
          Zmiana dat z ręcznymi rabatami
        </h3>
        <div className="space-y-4 mb-6">
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
            <p className="text-amber-800 font-medium mb-2">
              Masz ustawione ręczne rabaty na noclegi
            </p>
            <p className="text-amber-700 text-sm">
              Zmiana dat lub pokoi może powodować, że ręczne rabaty nie będą
              odpowiadać nowej konfiguracji. Co chcesz zrobić?
            </p>
          </div>
        </div>
        <div className="flex flex-col space-y-3">
          <button
            onClick={onRecalculateAuto}
            disabled={isLoading}
            className="w-full px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-50"
          >
            Przelicz automatycznie
          </button>
          <button
            onClick={onKeepManual}
            disabled={isLoading}
            className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
          >
            Zostaw ręczne
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiscountWarningModal;
